<div
  [style.height]="'100%'"
  [style.minHeight]="minHeight + 'px'"
  style="overflow-y:auto; display:block; margin-bottom:0"
>
  <div class="table-responsive" style="width: 100%;" *ngIf="status === 1">
    <table class="table" style="margin-bottom:0">
      <thead *ngIf="datos?.Table?.ShowHeader !== false">
        <tr style=" text-align: center; ">
          <th
            *ngFor="let th of columns"
            [style.width]="th.WidthPixels + 'px'"
            [style.textAlign]="getAlignment(th.Alignment)"
          >
            {{ th.Title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of tableDataDynamic; let z = index" [style.background]="(row.BackgroundColor !== null) ? rgbToHexa(row.BackgroundColor) : null">
          <td *ngFor="let col of columns; let i = index"   
          [style.width]="columns[i]?.WidthPixels ? columns[i].WidthPixels + 'px': '50px'"
          [style.textAlign]="columns[i] ? getAlignment(columns[i].Alignment): 'center'"
          >
            <ng-container [ngSwitch]="row.Data[col.Key]?.Type">
              
              <span *ngSwitchCase="'text'">{{ row.Data[col.Key]?.Value }}</span>
              <i *ngSwitchCase="'icon'"
                [class]="row.Data[col.Key]?.IconClass"
                [style.color]="row.Data[col.Key]?.Color"
                [tooltip]="row.Data[col.Key]?.Title" 
                style="font-size: 1.5rem; display: inline-flex; align-items: center; justify-content: center; width: 42px; height: 40px; border: 2px solid; border-radius: 50%;">
              </i>
              <ng-container *ngSwitchCase="'dropdown'">
                <div dropdown container="body" #dropdown="bs-dropdown">
                  <a class="btn btn-actions d-inline-flex align-items-center gap-2"
                    dropdownToggle
                    style="background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 20px; padding: 4px 12px; font-size: 0.875rem;">
                    {{ row.Data[col.Key]?.Value }}
                    <i class="fas fa-chevron-down ml-1" style="font-size: 0.75rem;"></i>
                  </a>
                  <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
                    <li *ngFor="let opt of row.Data[col.Key]?.Options" style="cursor: pointer;">
                      <button class="dropdown-item"
                        *ngIf="opt !== row.Data[col.Key]?.Value"
                        (click)="onDropdownChange(row, col.Key, opt, dropdown)">
                        {{ opt }}
                      </button>
                    </li>
                  </ul>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'actions'">
                <button *ngFor="let btn of row.Data[col.Key]?.Buttons"
                  [class]="btn.Class"
                  [tooltip]="btn.Tooltip"
                  (click)="btn.Action()"
                  style="margin: 0 2px; color:var(--primary)">
                  <i [class]="'fa ' + btn.Icon"></i>
                </button>
              </ng-container>
      
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="flex-align-center" *ngIf="status === 0">
    <i class="fas fa-circle-notch fa-spin fa-2x"></i>
  </div>
  <div class="flex-align-center" *ngIf="status === 2 && _appService.CoreCommonLiterals">
    <h5 class="text-muted">{{ _appService.CoreCommonLiterals.NoDataFound}}</h5>
  </div>

</div>
